<template>
  <div>
    <el-dialog
      title="批量导入"
      :visible.sync="visible"
      width="40%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @closed="handleDialogClosed"
    >
      <el-form class="qcFrom dialogScoped">
        <el-form-item label="选择机构">
          <el-select
            v-model="currentHospitalGuid"
            placeholder="请选择机构"
            class="multiple"
            filterable
            clearable
          >
            <el-option
              v-for="(item, index) in allHospitalsData"
              :key="index"
              :label="item.HospitalName"
              :value="item.HospitalGuid"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="batch-upload-container">
        <!-- 第一步：下载模板 -->
        <div class="step-section">
          <h3>第一步: 下载Excel导入模板文件</h3>
          <div class="tip-text">
            编辑导入模板时，请按照单元格样式，请勿修改，以保证数据有效性。
            <br />
            <a class="download-link" @click="downloadTemplate">
              下载导入模板
            </a>
          </div>
        </div>

        <!-- 第二步：上传文件 -->
        <div class="step-section">
          <h3>第二步: 上传编辑好的Excel文件</h3>
          <el-upload
            ref="upload"
            class="upload-demo"
            :action="uploadUrl"
            :headers="headers"
            :before-upload="beforeUpload"
            :on-success="handleSuccess"
            :on-error="handleError"
            accept=".xlsx,.xls"
            :show-file-list="true"
            :http-request="customUpload"
            :disabled="uploadProgress > 0 && uploadProgress < 100"
            drag
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              <p>支持 .xlsx、.xls 格式，文件大小限制 10MB 以内</p>
              <p>注：如果数据已存在，则会更新数据</p>
            </div>
          </el-upload>
          <el-progress
            v-if="uploadProgress > 0"
            :percentage="uploadProgress"
            :status="uploadStatus"
            class="upload-progress"
          ></el-progress>
        </div>
      </div>
      <div class="batch-upload-footer">
        <el-button type="primary" @click="handleClose">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Api from "../../../api";
import axios from "axios";
import oldAxios from "@/js/api";

export default {
  name: "BathUploadReportDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      allHospitalsData: [],
      currentHospitalGuid: "",
      uploadUrl:
        process.env.VUE_APP_BASE_API + Api.api.manager.UploadBatchReport,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      data: {
        hospitalGuid: "222",
      },
      uploadProgress: 0,
      uploadStatus: "", // 可能的值: "", "success", "exception"
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    axios
      .get(process.env.VUE_APP_BASE_API + Api.api.manager.GetHandReportHospital)
      .then((res) => {
        console.log(res, "222222");
        if (res.status === 200 && res.data) {
          this.allHospitalsData = res.data.Data;
        }
      });
  },
  methods: {
    handleClose() {
      this.visible = false;
      this.$emit("input", false);
    },
    downloadTemplate() {
      // 实现下载模板的逻辑
      window.open(
        process.env.VUE_APP_BASE_API + Api.api.manager.DownloadReportTemplate,
        "_blank"
      );
    },
    beforeUpload(file) {
      // 是否选择中心
      if (!this.currentHospitalGuid) {
        this.$message.error("请选择机构");
        return false;
      }
      // 检查文件类型
      const isExcel =
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";
      if (!isExcel) {
        this.$message.error("只能上传 Excel 格式文件!");
        return false;
      }
      // 检查文件大小（10MB = 10 * 1024 * 1024 bytes）
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("上传文件大小不能超过 10MB!");
        return false;
      }

      return true;
    },
    customUpload({ file }) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("hospitalGuid", this.currentHospitalGuid);
      // 重置进度条状态
      this.uploadProgress = 0;
      this.uploadStatus = "";

      axios
        .post(
          this.uploadUrl + "?hospitalGuid=" + this.currentHospitalGuid,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              ...this.headers,
            },
            onUploadProgress: (progressEvent) => {
              this.uploadProgress = Math.round(
                (progressEvent.loaded / progressEvent.total) * 100
              );
            },
          }
        )
        .then((response) => {
          this.$refs.upload.clearFiles();
          console.log(response, "mmmmmmmm");
          if (response.data.StatusCode === 30001) {
            this.uploadStatus = "exception";
            this.uploadReportError(response.data.Data);
            this.$message.error(response.data.Msg || "上传失败");
          } else {
            this.uploadStatus = "success";
            this.handleSuccess(response.data);
          }
        })
        .catch(() => {
          this.uploadStatus = "exception";
          this.handleError();
        });
    },
    // 上报异常
    uploadReportError(data) {
      this.$refs.upload.clearFiles();
      window.open(
        process.env.VUE_APP_BASE_API +
          Api.api.manager.UploadErrorReport +
          "?path=" +
          data,
        "_blank"
      );
      // oldAxios
      //   .ajaxGet("get", Api.api.manager.UploadErrorReport, {
      //     path: data,
      //   })
      //   .then((res) => {
      //     console.log(res, "上报成功");
      //   });
    },
    handleSuccess(response) {
      if (response.StatusCode === 200) {
        this.$message.success("上传成功");
        this.visible = false;
        this.$emit("uploadSuccess");
      } else {
        this.$message.error(response.Msg || "上传失败");
      }
      // 清除文件列表
      this.$refs.upload.clearFiles();
    },
    handleError() {
      this.$message.error("上传失败");
      // 清除文件列表
      this.$refs.upload.clearFiles();
    },
    handleDialogClosed() {
      // 重置所有状态
      this.$emit("input", false);
      this.$refs.upload.clearFiles();
      this.uploadProgress = 0;
      this.uploadStatus = "";
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .qcFrom .el-input__inner {
  background-color: #494d57 !important;
  color: #fff;
}
.batch-upload-container {
  // background-color: #1f2d3d;

  .step-section {
    margin-bottom: 30px;

    h3 {
      font-size: 16px;
      margin-bottom: 15px;
      color: #e4e7ed;
    }

    .tip-text {
      margin-top: 10px;
      color: #a8abb2;
      font-size: 14px;
      line-height: 1.5;
    }
  }

  .download-link {
    cursor: pointer;
    color: #409eff;
    text-decoration: underline;
    padding: 0;
    font-weight: 500;

    &:hover {
      color: #66b1ff;
      opacity: 0.8;
    }
  }

  .upload-demo {
    .el-upload {
      width: 100%;

      .el-upload-dragger {
        width: 100%;
        height: 200px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #3d4049;
        // background-color: #283446;
        border: 1px dashed #5e6d82;

        &:hover {
          border-color: #409eff;
          background-color: #2d3e58;
        }

        .el-icon-upload {
          font-size: 40px;
          color: #878d99;
          margin-bottom: 10px;
        }

        .el-upload__text {
          color: #a8abb2;
          font-size: 14px;

          em {
            color: #409eff;
            font-style: normal;
          }
        }
      }
    }

    .el-upload__tip {
      color: #878d99;
      font-size: 12px;
      line-height: 1.5;
      margin-top: 10px;

      p {
        margin: 5px 0;
      }
    }

    .upload-progress {
      margin-top: 15px;
    }
  }
}

::v-deep .el-upload-dragger {
  background-color: rgb(40, 43, 50);
}
.batch-upload-footer {
  display: flex;
  justify-content: center;
}

// 自定义进度条颜色
::v-deep .el-progress-bar__inner {
  // 成功状态
  .el-progress-bar__innerText {
    color: #fff;
  }
}

::v-deep .el-progress {
  &.is-success {
    .el-progress-bar__inner {
      background-color: #67c23a;
    }
  }
  &.is-exception {
    .el-progress-bar__inner {
      background-color: #f56c6c;
    }
  }
}
</style>
